module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/theme/lindtbShop/ortho-field-config-translation.json
// module id = 1256
// module chunks = 0